import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./NewShareAccessPage.css";
import { OrbitProgress } from "react-loading-indicators";

const NewShareAccessPage = () => {
  const navigate = useNavigate();
  const { accessToken } = useParams();

  useEffect(() => {
    sharingProcess();
  }, []);

  const sharingProcess = async () => {
    navigate(`/share/access?token=${accessToken}`);
  };

  return (
    <div className="App">
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <OrbitProgress color="#C1C7D4" />
      </div>
    </div>
  );
};

export default NewShareAccessPage;
